import ACTIONS from '../../auth/AuthActions';
import _ from "lodash";

const initialState = {
    networkRequests: 0,
    identity: null,
    access: {
        accessLevel: {
            isAdmin: false,
            isSiteAdmin: false,
            isSupervisor: false,
            isDPAdmin: false,
            isDPEditor: false,
            isPricingAdmin: false,
            isBillingAdmin: false,
        },
        accessToken: null,
    },
    lastError: null,
    authorized: false,
};

/**
 * Reducer to store user, user rights and
 * related information in the state.
 */
const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case ACTIONS.Types.NETWORK_START: {
            let newState = _.cloneDeep(state);
            newState.networkRequests += 1;
            return newState;
        }
        case ACTIONS.Types.NETWORK_STOP:{
            let newState = _.cloneDeep(state);
            newState.networkRequests -= 1;
            return newState;
        }

        case ACTIONS.Types.SIGN_IN: {
            let newState = _.cloneDeep(state);
            newState.identity = action.payload.account;
            newState.authorized = true;
            return newState;
        }

        case ACTIONS.Types.ADD_USER_RIGHTS: {
            let newState = _.cloneDeep(state);
            newState.access.accessLevel = action.payload;
            return newState;
        }
        case ACTIONS.Types.NETWORK_ERROR:
            return { ...state, lastError: action.error };

        default:
            return state;
    }
};

export default userReducer;
